import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type inputType = RouterInputs['SocialManager']['getRack']
type queryOptionsType = ReactQueryOptions['SocialManager']['getRack']

export const useGetRack = (input: inputType, options?: queryOptionsType) => {
    return api.SocialManager.getRack.useQuery(input, {
        ...options,
        queryKey: ['SocialManager.getRack', input],
        staleTime: 1000 * staleTimeIndex * 60 * 60, // 1 hour
    })
}
